var me = Object.defineProperty;
var ye = (e, t, r) => t in e ? me(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var y = (e, t, r) => (ye(e, typeof t != "symbol" ? t + "" : t, r), r);
let M;
function ve(e) {
  M = e;
}
function k() {
  if (M === void 0)
    throw new Error("API key is not set");
  return M;
}
let te = "https://api.getpolaris.ai/api/v1";
function be(e) {
  te = e;
}
function H() {
  return te;
}
var h = typeof globalThis < "u" && globalThis || typeof self < "u" && self || // eslint-disable-next-line no-undef
typeof global < "u" && global || {}, d = {
  searchParams: "URLSearchParams" in h,
  iterable: "Symbol" in h && "iterator" in Symbol,
  blob: "FileReader" in h && "Blob" in h && function() {
    try {
      return new Blob(), !0;
    } catch {
      return !1;
    }
  }(),
  formData: "FormData" in h,
  arrayBuffer: "ArrayBuffer" in h
};
function Te(e) {
  return e && DataView.prototype.isPrototypeOf(e);
}
if (d.arrayBuffer)
  var ge = [
    "[object Int8Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]",
    "[object Int16Array]",
    "[object Uint16Array]",
    "[object Int32Array]",
    "[object Uint32Array]",
    "[object Float32Array]",
    "[object Float64Array]"
  ], we = ArrayBuffer.isView || function(e) {
    return e && ge.indexOf(Object.prototype.toString.call(e)) > -1;
  };
function E(e) {
  if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || e === "")
    throw new TypeError('Invalid character in header field name: "' + e + '"');
  return e.toLowerCase();
}
function F(e) {
  return typeof e != "string" && (e = String(e)), e;
}
function N(e) {
  var t = {
    next: function() {
      var r = e.shift();
      return { done: r === void 0, value: r };
    }
  };
  return d.iterable && (t[Symbol.iterator] = function() {
    return t;
  }), t;
}
function l(e) {
  this.map = {}, e instanceof l ? e.forEach(function(t, r) {
    this.append(r, t);
  }, this) : Array.isArray(e) ? e.forEach(function(t) {
    if (t.length != 2)
      throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + t.length);
    this.append(t[0], t[1]);
  }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
    this.append(t, e[t]);
  }, this);
}
l.prototype.append = function(e, t) {
  e = E(e), t = F(t);
  var r = this.map[e];
  this.map[e] = r ? r + ", " + t : t;
};
l.prototype.delete = function(e) {
  delete this.map[E(e)];
};
l.prototype.get = function(e) {
  return e = E(e), this.has(e) ? this.map[e] : null;
};
l.prototype.has = function(e) {
  return this.map.hasOwnProperty(E(e));
};
l.prototype.set = function(e, t) {
  this.map[E(e)] = F(t);
};
l.prototype.forEach = function(e, t) {
  for (var r in this.map)
    this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
};
l.prototype.keys = function() {
  var e = [];
  return this.forEach(function(t, r) {
    e.push(r);
  }), N(e);
};
l.prototype.values = function() {
  var e = [];
  return this.forEach(function(t) {
    e.push(t);
  }), N(e);
};
l.prototype.entries = function() {
  var e = [];
  return this.forEach(function(t, r) {
    e.push([r, t]);
  }), N(e);
};
d.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
function U(e) {
  if (!e._noBody) {
    if (e.bodyUsed)
      return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }
}
function re(e) {
  return new Promise(function(t, r) {
    e.onload = function() {
      t(e.result);
    }, e.onerror = function() {
      r(e.error);
    };
  });
}
function Se(e) {
  var t = new FileReader(), r = re(t);
  return t.readAsArrayBuffer(e), r;
}
function Ae(e) {
  var t = new FileReader(), r = re(t), o = /charset=([A-Za-z0-9_-]+)/.exec(e.type), n = o ? o[1] : "utf-8";
  return t.readAsText(e, n), r;
}
function Ee(e) {
  for (var t = new Uint8Array(e), r = new Array(t.length), o = 0; o < t.length; o++)
    r[o] = String.fromCharCode(t[o]);
  return r.join("");
}
function X(e) {
  if (e.slice)
    return e.slice(0);
  var t = new Uint8Array(e.byteLength);
  return t.set(new Uint8Array(e)), t.buffer;
}
function ne() {
  return this.bodyUsed = !1, this._initBody = function(e) {
    this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : d.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : d.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : d.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : d.arrayBuffer && d.blob && Te(e) ? (this._bodyArrayBuffer = X(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : d.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || we(e)) ? this._bodyArrayBuffer = X(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : d.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
  }, d.blob && (this.blob = function() {
    var e = U(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return Promise.resolve(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(new Blob([this._bodyArrayBuffer]));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as blob");
    return Promise.resolve(new Blob([this._bodyText]));
  }), this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var e = U(this);
      return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
        this._bodyArrayBuffer.buffer.slice(
          this._bodyArrayBuffer.byteOffset,
          this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
        )
      ) : Promise.resolve(this._bodyArrayBuffer));
    } else {
      if (d.blob)
        return this.blob().then(Se);
      throw new Error("could not read as ArrayBuffer");
    }
  }, this.text = function() {
    var e = U(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return Ae(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(Ee(this._bodyArrayBuffer));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as text");
    return Promise.resolve(this._bodyText);
  }, d.formData && (this.formData = function() {
    return this.text().then(Oe);
  }), this.json = function() {
    return this.text().then(JSON.parse);
  }, this;
}
var Be = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
function Pe(e) {
  var t = e.toUpperCase();
  return Be.indexOf(t) > -1 ? t : e;
}
function w(e, t) {
  if (!(this instanceof w))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  t = t || {};
  var r = t.body;
  if (e instanceof w) {
    if (e.bodyUsed)
      throw new TypeError("Already read");
    this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !r && e._bodyInit != null && (r = e._bodyInit, e.bodyUsed = !0);
  } else
    this.url = String(e);
  if (this.credentials = t.credentials || this.credentials || "same-origin", (t.headers || !this.headers) && (this.headers = new l(t.headers)), this.method = Pe(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
    if ("AbortController" in h) {
      var i = new AbortController();
      return i.signal;
    }
  }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && r)
    throw new TypeError("Body not allowed for GET or HEAD requests");
  if (this._initBody(r), (this.method === "GET" || this.method === "HEAD") && (t.cache === "no-store" || t.cache === "no-cache")) {
    var o = /([?&])_=[^&]*/;
    if (o.test(this.url))
      this.url = this.url.replace(o, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
    else {
      var n = /\?/;
      this.url += (n.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
    }
  }
}
w.prototype.clone = function() {
  return new w(this, { body: this._bodyInit });
};
function Oe(e) {
  var t = new FormData();
  return e.trim().split("&").forEach(function(r) {
    if (r) {
      var o = r.split("="), n = o.shift().replace(/\+/g, " "), i = o.join("=").replace(/\+/g, " ");
      t.append(decodeURIComponent(n), decodeURIComponent(i));
    }
  }), t;
}
function Ce(e) {
  var t = new l(), r = e.replace(/\r?\n[\t ]+/g, " ");
  return r.split("\r").map(function(o) {
    return o.indexOf(`
`) === 0 ? o.substr(1, o.length) : o;
  }).forEach(function(o) {
    var n = o.split(":"), i = n.shift().trim();
    if (i) {
      var c = n.join(":").trim();
      try {
        t.append(i, c);
      } catch (u) {
        console.warn("Response " + u.message);
      }
    }
  }), t;
}
ne.call(w.prototype);
function p(e, t) {
  if (!(this instanceof p))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  if (t || (t = {}), this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.status < 200 || this.status > 599)
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
  this.ok = this.status >= 200 && this.status < 300, this.statusText = t.statusText === void 0 ? "" : "" + t.statusText, this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e);
}
ne.call(p.prototype);
p.prototype.clone = function() {
  return new p(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new l(this.headers),
    url: this.url
  });
};
p.error = function() {
  var e = new p(null, { status: 200, statusText: "" });
  return e.status = 0, e.type = "error", e;
};
var Le = [301, 302, 303, 307, 308];
p.redirect = function(e, t) {
  if (Le.indexOf(t) === -1)
    throw new RangeError("Invalid status code");
  return new p(null, { status: t, headers: { location: e } });
};
var g = h.DOMException;
try {
  new g();
} catch {
  g = function(t, r) {
    this.message = t, this.name = r;
    var o = Error(t);
    this.stack = o.stack;
  }, g.prototype = Object.create(Error.prototype), g.prototype.constructor = g;
}
function ie(e, t) {
  return new Promise(function(r, o) {
    var n = new w(e, t);
    if (n.signal && n.signal.aborted)
      return o(new g("Aborted", "AbortError"));
    var i = new XMLHttpRequest();
    function c() {
      i.abort();
    }
    i.onload = function() {
      var a = {
        statusText: i.statusText,
        headers: Ce(i.getAllResponseHeaders() || "")
      };
      n.url.startsWith("file://") && (i.status < 200 || i.status > 599) ? a.status = 200 : a.status = i.status, a.url = "responseURL" in i ? i.responseURL : a.headers.get("X-Request-URL");
      var m = "response" in i ? i.response : i.responseText;
      setTimeout(function() {
        r(new p(m, a));
      }, 0);
    }, i.onerror = function() {
      setTimeout(function() {
        o(new TypeError("Network request failed"));
      }, 0);
    }, i.ontimeout = function() {
      setTimeout(function() {
        o(new TypeError("Network request timed out"));
      }, 0);
    }, i.onabort = function() {
      setTimeout(function() {
        o(new g("Aborted", "AbortError"));
      }, 0);
    };
    function u(a) {
      try {
        return a === "" && h.location.href ? h.location.href : a;
      } catch {
        return a;
      }
    }
    if (i.open(n.method, u(n.url), !0), n.credentials === "include" ? i.withCredentials = !0 : n.credentials === "omit" && (i.withCredentials = !1), "responseType" in i && (d.blob ? i.responseType = "blob" : d.arrayBuffer && (i.responseType = "arraybuffer")), t && typeof t.headers == "object" && !(t.headers instanceof l || h.Headers && t.headers instanceof h.Headers)) {
      var s = [];
      Object.getOwnPropertyNames(t.headers).forEach(function(a) {
        s.push(E(a)), i.setRequestHeader(a, F(t.headers[a]));
      }), n.headers.forEach(function(a, m) {
        s.indexOf(m) === -1 && i.setRequestHeader(m, a);
      });
    } else
      n.headers.forEach(function(a, m) {
        i.setRequestHeader(m, a);
      });
    n.signal && (n.signal.addEventListener("abort", c), i.onreadystatechange = function() {
      i.readyState === 4 && n.signal.removeEventListener("abort", c);
    }), i.send(typeof n._bodyInit > "u" ? null : n._bodyInit);
  });
}
ie.polyfill = !0;
h.fetch || (h.fetch = ie, h.Headers = l, h.Request = w, h.Response = p);
async function _e() {
  const t = await (await fetch(`${H()}/connection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      apiKey: k()
    })
  })).json();
  if (t.error)
    throw new Error(t.error);
}
var v, O, oe, L, ae = -1, C = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (ae = t.timeStamp, e(t));
  }, !0);
}, se = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, G = function() {
  var e = se();
  return e && e.activationStart || 0;
}, b = function(e, t) {
  var r = se(), o = "navigate";
  return ae >= 0 ? o = "back-forward-cache" : r && (document.prerendering || G() > 0 ? o = "prerender" : document.wasDiscarded ? o = "restore" : r.type && (o = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: o };
}, x = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var o = new PerformanceObserver(function(n) {
        Promise.resolve().then(function() {
          t(n.getEntries());
        });
      });
      return o.observe(Object.assign({ type: e, buffered: !0 }, r || {})), o;
    }
  } catch {
  }
}, T = function(e, t, r, o) {
  var n, i;
  return function(c) {
    t.value >= 0 && (c || o) && ((i = t.value - (n || 0)) || n === void 0) && (n = t.value, t.delta = i, t.rating = function(u, s) {
      return u > s[1] ? "poor" : u > s[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, V = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, j = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, K = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, S = -1, J = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, _ = function(e) {
  document.visibilityState === "hidden" && S > -1 && (S = e.type === "visibilitychange" ? e.timeStamp : 0, xe());
}, z = function() {
  addEventListener("visibilitychange", _, !0), addEventListener("prerenderingchange", _, !0);
}, xe = function() {
  removeEventListener("visibilitychange", _, !0), removeEventListener("prerenderingchange", _, !0);
}, W = function() {
  return S < 0 && (S = J(), z(), C(function() {
    setTimeout(function() {
      S = J(), z();
    }, 0);
  })), { get firstHiddenTime() {
    return S;
  } };
}, q = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, $ = [1800, 3e3], Ue = function(e, t) {
  t = t || {}, q(function() {
    var r, o = W(), n = b("FCP"), i = x("paint", function(c) {
      c.forEach(function(u) {
        u.name === "first-contentful-paint" && (i.disconnect(), u.startTime < o.firstHiddenTime && (n.value = Math.max(u.startTime - G(), 0), n.entries.push(u), r(!0)));
      });
    });
    i && (r = T(e, n, $, t.reportAllChanges), C(function(c) {
      n = b("FCP"), r = T(e, n, $, t.reportAllChanges), V(function() {
        n.value = performance.now() - c.timeStamp, r(!0);
      });
    }));
  });
}, Q = [0.1, 0.25], De = function(e, t) {
  t = t || {}, Ue(K(function() {
    var r, o = b("CLS", 0), n = 0, i = [], c = function(s) {
      s.forEach(function(a) {
        if (!a.hadRecentInput) {
          var m = i[0], pe = i[i.length - 1];
          n && a.startTime - pe.startTime < 1e3 && a.startTime - m.startTime < 5e3 ? (n += a.value, i.push(a)) : (n = a.value, i = [a]);
        }
      }), n > o.value && (o.value = n, o.entries = i, r());
    }, u = x("layout-shift", c);
    u && (r = T(e, o, Q, t.reportAllChanges), j(function() {
      c(u.takeRecords()), r(!0);
    }), C(function() {
      n = 0, o = b("CLS", 0), r = T(e, o, Q, t.reportAllChanges), V(function() {
        return r();
      });
    }), setTimeout(r, 0));
  }));
}, B = { passive: !0, capture: !0 }, Re = /* @__PURE__ */ new Date(), Y = function(e, t) {
  v || (v = t, O = e, oe = /* @__PURE__ */ new Date(), ue(removeEventListener), ce());
}, ce = function() {
  if (O >= 0 && O < oe - Re) {
    var e = { entryType: "first-input", name: v.type, target: v.target, cancelable: v.cancelable, startTime: v.timeStamp, processingStart: v.timeStamp + O };
    L.forEach(function(t) {
      t(e);
    }), L = [];
  }
}, Ie = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, o) {
      var n = function() {
        Y(r, o), c();
      }, i = function() {
        c();
      }, c = function() {
        removeEventListener("pointerup", n, B), removeEventListener("pointercancel", i, B);
      };
      addEventListener("pointerup", n, B), addEventListener("pointercancel", i, B);
    }(t, e) : Y(t, e);
  }
}, ue = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, Ie, B);
  });
}, Z = [100, 300], Me = function(e, t) {
  t = t || {}, q(function() {
    var r, o = W(), n = b("FID"), i = function(s) {
      s.startTime < o.firstHiddenTime && (n.value = s.processingStart - s.startTime, n.entries.push(s), r(!0));
    }, c = function(s) {
      s.forEach(i);
    }, u = x("first-input", c);
    r = T(e, n, Z, t.reportAllChanges), u && j(K(function() {
      c(u.takeRecords()), u.disconnect();
    })), u && C(function() {
      var s;
      n = b("FID"), r = T(e, n, Z, t.reportAllChanges), L = [], O = -1, v = null, ue(addEventListener), s = i, L.push(s), ce();
    });
  });
}, ee = [2500, 4e3], D = {}, He = function(e, t) {
  t = t || {}, q(function() {
    var r, o = W(), n = b("LCP"), i = function(s) {
      var a = s[s.length - 1];
      a && a.startTime < o.firstHiddenTime && (n.value = Math.max(a.startTime - G(), 0), n.entries = [a], r());
    }, c = x("largest-contentful-paint", i);
    if (c) {
      r = T(e, n, ee, t.reportAllChanges);
      var u = K(function() {
        D[n.id] || (i(c.takeRecords()), c.disconnect(), D[n.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach(function(s) {
        addEventListener(s, function() {
          return setTimeout(u, 0);
        }, !0);
      }), j(u), C(function(s) {
        n = b("LCP"), r = T(e, n, ee, t.reportAllChanges), V(function() {
          n.value = performance.now() - s.timeStamp, D[n.id] = !0, r(!0);
        });
      });
    }
  });
}, P = /* @__PURE__ */ ((e) => (e.FAST = "FAST", e.OK = "OK", e.SLOW = "SLOW", e.SLOWEST = "SLOWEST", e))(P || {}), f = /* @__PURE__ */ ((e) => (e.BOT = "BOT", e.CAR = "CAR", e.DESKTOP = "DESKTOP", e.PHONE = "PHONE", e.TABLET = "TABLET", e.TV = "TV", e))(f || {}), A = /* @__PURE__ */ ((e) => (e.FAILURE = "FAILURE", e.SUCCESS = "SUCCESS", e))(A || {});
const fe = (e) => {
  !window.navigator || !window.navigator.sendBeacon ? fetch(`${H()}/measurement`, {
    method: "POST",
    body: JSON.stringify(e),
    headers: {
      "Content-Type": "application/json"
    }
  }) : window.navigator.sendBeacon(
    `${H()}/measurement`,
    JSON.stringify(e)
  );
};
function le() {
  if (window.navigator.connection)
    switch (window.navigator.connection.effectiveType) {
      case "slow-2g":
        return P.SLOWEST;
      case "2g":
        return P.SLOW;
      case "3g":
        return P.OK;
      case "4g":
      default:
        return P.FAST;
    }
  return null;
}
/**
 * @license MIT
 * @author Rodrigo Guerreiro
 * @source https://github.com/rguerreiro/device
 */
function he() {
  let e = window.navigator.userAgent;
  return !e || e === "" ? f.DESKTOP : (e.match(/FlipboardProxy/i) && (e = "FlipboardProxy/1.1;  http://flipboard.com/browserproxy"), e.match(/Applebot/i) && (e = "Applebot/0.1;  http://www.apple.com/go/applebot"), e.match(
    /GoogleTV|SmartTV|SMART-TV|Internet TV|NetCast|NETTV|AppleTV|boxee|Kylo|Roku|DLNADOC|hbbtv|CrKey|CE-HTML/i
  ) || e.match(/Xbox|PLAYSTATION (3|4)|Wii/i) ? f.TV : e.match(/QtCarBrowser/i) ? f.CAR : e.match(/Googlebot|bingbot/i) || e.match(/WhatsApp/i) ? f.BOT : e.match(/iP(a|ro)d/i) || e.match(/tablet/i) && !e.match(/RX-34/i) || e.match(/FOLIO/i) || e.match(/Linux/i) && e.match(/Android/i) && !e.match(/Fennec|mobi|HTC Magic|HTCX06HT|Nexus One|SC-02B|fone 945/i) || e.match(/Kindle/i) || e.match(/Mac OS/i) && e.match(/Silk/i) || e.match(/AppleWebKit/i) && e.match(/Silk/i) && !e.match(/Playstation Vita/i) || e.match(
    /GT-P10|SC-01C|SHW-M180S|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook/i
  ) || e.match(/MB511/i) && e.match(/RUTEM/i) ? f.TABLET : e.match(
    /BOLT|Fennec|Iris|Maemo|Minimo|Mobi|mowser|NetFront|Novarra|Prism|RX-34|Skyfire|Tear|XV6875|XV6975|Google Wireless Transcoder/i
  ) && !e.match(/AdsBot-Google-Mobile/i) || e.match(/Opera/i) && e.match(/Windows NT 5/i) && e.match(/HTC|Xda|Mini|Vario|SAMSUNG-GT-i8000|SAMSUNG-SGH-i9/i) ? f.PHONE : e.match(/Windows( )?(NT|XP|ME|9)/) && !e.match(/Phone/i) && !e.match(/Bot|Spider|ia_archiver|NewsGator/i) || e.match(/Win( ?9|NT)/i) || e.match(/Go-http-client/i) || e.match(/Macintosh|PowerPC/i) && !e.match(/Silk|moatbot/i) || e.match(/Linux/i) && e.match(/X11/i) && !e.match(/Charlotte|JobBot/i) || e.match(/CrOS/) || e.match(/Solaris|SunOS|BSD/i) ? f.DESKTOP : e.match(/Mozilla\/5\.0 \(\)|AdsBot-Google-Mobile/i) && e.match(/Phone/i) || e.match(
    /Mozilla\/5\.0 \(\)|jack|Applebot|FlipboardProxy|Go 1.1 package|HTMLParser|simplereach|python-requests|ShowyouBot|MetaURI|nineconnections|(^Java\/[0-9._]*)|Commons-HttpClient|InAGist|HTTP-Java-Client|curl|Wget|Bot|B-O-T|Crawler|Spider|Spyder|Yahoo|ia_archiver|Covario-IDS|findlinks|DataparkSearch|larbin|Mediapartners-Google|NG-Search|Snappy|Teoma|Jeeves|Charlotte|NewsGator|TinEye|Cerberian|SearchSight|Zao|Scrubby|Qseero|PycURL|Pompos|oegp|SBIder|yoogliFetchAgent|yacy|webcollage|VYU2|voyager|updated|truwoGPS|StackRambler|Sqworm|silk|semanticdiscovery|ScoutJet|Nymesis|NetResearchServer|MVAClient|mogimogi|Mnogosearch|Arachmo|Accoona|holmes|htdig|ichiro|webis|LinkWalker|lwp-trivial|facebookexternalhit|monit\/|ELB-HealthChecker\/|JobBot|GoogleCloudMonitoring|GoogleStackdriverMonitoring|gomezagent|apm synthetic agent|ruxitsynthetic|ktxn|khte|ktht|dynatrace|TrendsmapResolver|WinHTTP/i
  ) && !e.match(/phone|Playstation/i) ? f.BOT : f.DESKTOP);
}
function R(e, t, r, o = {}, n = {}) {
  fe({
    result: t,
    apiKey: k(),
    name: e,
    duration: r,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    metadata: {
      connectionQuality: le(),
      deviceType: he(),
      userMetadata: {
        ...o,
        ...n
      }
    }
  });
}
function ke(e = {}) {
  De((t) => {
    R(
      t.name,
      A.SUCCESS,
      t.value,
      e,
      t
    );
  }), Me((t) => {
    R(
      t.name,
      A.SUCCESS,
      t.value,
      e,
      t
    );
  }), He((t) => {
    R(
      t.name,
      A.SUCCESS,
      t.value,
      e,
      t
    );
  });
}
const Ge = async (e) => {
  ve(e.apiKey), e.apiUrl && be(e.apiUrl), await _e(), e.collectWebVitals && ke();
};
class de {
  constructor(t, r = {}) {
    y(this, "connectionQuality", le());
    y(this, "deviceType", he());
    y(this, "created", performance.now());
    this.eventName = t, this.userMeasurementMetadata = r;
  }
  sendMeasurement(t, r = {}) {
    fe({
      result: t,
      apiKey: k(),
      name: this.eventName,
      duration: performance.now() - this.created,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      metadata: {
        connectionQuality: this.connectionQuality,
        deviceType: this.deviceType,
        userMetadata: {
          ...this.userMeasurementMetadata,
          ...r
        }
      }
    });
  }
  done(t = {}) {
    this.sendMeasurement(A.SUCCESS, t);
  }
  fail(t = {}) {
    this.sendMeasurement(A.FAILURE, t);
  }
}
function Ve(e, t) {
  return new de(e, t);
}
class Fe {
  constructor(t) {
    y(this, "instrument", null);
    y(this, "start", (t = {}) => {
      this.instrument ? console.warn(
        "@getpolaris.ai/sdk: Instrument already started",
        this.eventName
      ) : this.instrument = new de(this.eventName, t);
    });
    y(this, "done", (t = {}) => {
      this.instrument ? (this.instrument.done(t), this.instrument = null) : console.warn(
        "@getpolaris.ai/sdk: Instrument not started",
        this.eventName
      );
    });
    y(this, "fail", (t = {}) => {
      this.instrument ? (this.instrument.fail(t), this.instrument = null) : console.warn(
        "@getpolaris.ai/sdk: Instrument not started",
        this.eventName
      );
    });
    this.eventName = t;
  }
}
const I = /* @__PURE__ */ new Map();
function je(e) {
  I.has(e) || I.set(e, new Fe(e));
  const t = I.get(e);
  if (!t)
    throw new Error("Instrument not found");
  return t;
}
export {
  de as Instrument,
  Ge as createConnection,
  je as getInstrument,
  R as logMeasurement,
  Ve as measure
};
